import { CategoryScreen } from '../features/categories/CategoryScreen'
import { useShell } from '../app/outlet'

export function CategoryPage() {
  const { toast } = useShell()
  return <CategoryScreen onToast={toast} />
}
